import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSales } from '../../../../contexts/SalesContext';

export function useSaleCreation() {
  const navigate = useNavigate();
  const { addSale } = useSales();
  const [saleInProgress, setSaleInProgress] = useState({
    items: [],
    client: null
  });

  const handleSaleItemAdded = (item) => {
    setSaleInProgress(prev => ({
      ...prev,
      items: [...prev.items, {
        ...item,
        display_id: item.display_id
      }]
    }));
    navigate('/sales/review');
  };

  const handleEditItem = (index, updatedItem) => {
    setSaleInProgress(prev => ({
      ...prev,
      items: prev.items.map((item, i) => 
        i === index ? {
          ...updatedItem,
          lotId: updatedItem.lotId,
          title: updatedItem.title,
          quantity: updatedItem.quantity,
          unit: updatedItem.unit,
          unitPrice: updatedItem.unitPrice,
          deposit: updatedItem.deposit,
          container_deposit: updatedItem.container_deposit,
          subtotal: updatedItem.subtotal,
          totalDeposit: updatedItem.totalDeposit,
          is_lightning_lot: updatedItem.is_lightning_lot,
          display_id: item.display_id
        } : item
      )
    }));
  };

  const handleDeleteItem = (index) => {
    setSaleInProgress(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };

  const handleSelectClient = (client) => {
    setSaleInProgress(prev => ({
      ...prev,
      client
    }));
  };

  const handleSaleConfirmed = async (saleData) => {
    try {
      console.log('Datos de venta a crear:', {
        ...saleData,
        customer_name: saleData.client?.name,
        client_id: saleData.client?.id,
        items: saleData.items.map(item => ({
          lotId: item.lotId,
          quantity: item.quantity,
          unitPrice: item.unitPrice,
          deposit: item.deposit || 0,
          deposit_quantity: item.quantity,
          lot_id: item.lotId,
          unit_price: item.unitPrice,
          deposit_amount: item.deposit || 0,
          title: item.title
        }))
      });

      const newSale = await addSale({
        ...saleData,
        customer_name: saleData.client?.name,
        client_id: saleData.client?.id,
        items: saleData.items.map(item => ({
          lotId: item.lotId,
          quantity: item.quantity,
          unitPrice: item.unitPrice,
          deposit: item.deposit || 0,
          deposit_quantity: item.quantity,
          lot_id: item.lotId,
          unit_price: item.unitPrice,
          deposit_amount: item.deposit || 0,
          title: item.title
        }))
      });

      // Resetear el estado
      setSaleInProgress({
        items: [],
        client: null
      });

      // Navegar a la pantalla de éxito
      navigate(`/sales/success/${newSale.id}`);
    } catch (error) {
      console.error('Error al crear la venta:', error);
      // Aquí podrías mostrar un mensaje de error al usuario
    }
  };

  return {
    saleInProgress,
    handleSaleItemAdded,
    handleEditItem,
    handleDeleteItem,
    handleSelectClient,
    handleSaleConfirmed
  };
} 